export default function PlaceModel(dict) {
    this.locationId = dict.LocationID;
    this.name = dict.Name;
    this.latitude = dict.Latitude;
    this.longitude = dict.Longitude;

    // Property in api get place
    this.id = dict.id;
    this.buzz = dict.buzz;
    this.category = dict.category;
    this.checkin_count = dict.checkin_count;
    this.checkins = dict.checkins;

    this.description_place = dict.description_place;
    if (dict.description) {
        this.description_place = dict.description;
    }

    this.display_subtext = dict.display_subtext;
    this.distance = dict.distance;
    this.isBuzzeBeesPlace = dict.isBuzzeBeesPlace;

    // location
    if (dict.location) {
        this.latitude = dict.location.latitude;
        this.longitude = dict.location.longitude;
    }

    this.page_id = dict.page_id;
    this.rank = dict.rank;
    this.rating = dict.rating;
    this.taking_about_count = dict.taking_about_count;
    this.were_here_count = dict.were_here_count;
    this.workingDay = dict.working_day;

    this.contact_number = dict.contact_number;
    this.listServices = [];

    if (dict.services) {
        for (let service of dict.services) {
            let itemService = service;
            this.listServices.push({
                id: itemService.id,
                name: itemService.name
            });
        }
    }
}
